import Swal from 'sweetalert2/dist/sweetalert2.js'
import './toast.css'

export const Toast = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  customClass: {
    popup: 'jl-toast-popup',
    icon: 'jl-toast-icon',
    title: 'jl-toast-title',
    htmlContainer: 'jl-toast-html',
    timerProgressBar: 'jl-toast-timer-bar',
  },
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
});
